import developmentHosts from './development';
import localHosts from './local';
import productionHosts from './production';
import stageHosts from './stage';
import testHosts from './test';
import testCIHosts from './testCI';

export enum Host {
  CTL_AUTHENTICATOR_SERVER = 'CTL_AUTHENTICATOR_SERVER',
  CTL_DATA_SERVER = 'CTL_DATA_SERVER',
  CTL_IMAGE_SERVER = 'CTL_IMAGE_SERVER',
  CTL_ELASTIC_SEARCH = 'CTL_ELASTIC_SEARCH',
  AIPF_PORTAL_DOMAIN = 'AIPF_PORTAL_DOMAIN',
}

export type Hosts = Record<Host, string>;

const getDefaultHosts = (): Hosts => {
  const phase = import.meta.env.VITE_DEPLOYMENT_PHASE;

  switch (phase) {
    case 'production':
      return productionHosts;
    case 'stage':
      return stageHosts;
    case 'development':
      return developmentHosts;
    case 'test':
      return testHosts;
    case 'testCI':
      return testCIHosts;
    case 'local':
    default:
      return localHosts;
  }
};

const defaultHosts = getDefaultHosts();

// Override with environment variables if they exist
export const HOSTS: Hosts = {
  CTL_AUTHENTICATOR_SERVER:
    import.meta.env.VITE_CTL_AUTHENTICATOR_SERVER ||
    defaultHosts.CTL_AUTHENTICATOR_SERVER,
  CTL_DATA_SERVER:
    import.meta.env.VITE_CTL_DATA_SERVER || defaultHosts.CTL_DATA_SERVER,
  CTL_IMAGE_SERVER:
    import.meta.env.VITE_CTL_IMAGE_SERVER || defaultHosts.CTL_IMAGE_SERVER,
  CTL_ELASTIC_SEARCH:
    import.meta.env.VITE_CTL_ELASTIC_SEARCH || defaultHosts.CTL_ELASTIC_SEARCH,
  AIPF_PORTAL_DOMAIN:
    import.meta.env.VITE_AIPF_PORTAL_DOMAIN || defaultHosts.AIPF_PORTAL_DOMAIN,
};

export const SERVICE_NAME =
  import.meta.env.VITE_SERVICE_NAME || 'CTL Annotation Tool';
